import classNames from 'classnames';
import React from 'react';
import Typography from '@/components/atoms/typography/typography';
import styles from './dual-choice.module.scss';

export interface DualChoiceProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Indicates whether the field is checked */
  checked?: boolean;
  /** Indicates whether the field is disabled */
  disabled?: boolean;
  /** Indicates whether the field has an error */
  error?: boolean;
  /** String to uniquely identify the switch */
  id?: string;
  /** The text that is shown to the left of the switch */
  labelLeft?: string;
  /** The text that is shown to the right of the switch */
  labelRight?: string;
  /** An event that is triggered on click */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const DualChoice = ({
  checked,
  disabled,
  error,
  id,
  labelLeft,
  labelRight,
  ...rest
}: DualChoiceProps) => {
  return (
    <React.Fragment>
      <button
        {...rest}
        aria-checked={checked}
        aria-labelledby={id}
        className={classNames(styles.component, {
          [styles.isChecked]: checked,
          [styles.isDisabled]: disabled,
          [styles.hasError]: error,
        })}
        role="switch"
        tabIndex={0}
      >
        <label className={styles.labelContainer} id={id}>
          {labelLeft && (
            <Typography
              className={classNames(styles.label, styles.isLeft)}
              tag="span"
              tagStyle="bodySmall"
              title={labelLeft}
            >
              {labelLeft}
            </Typography>
          )}

          <div aria-hidden="true" className={styles.handleWrapper}>
            <div className={styles.handle} />
          </div>

          {labelRight && (
            <Typography
              className={classNames(styles.label, styles.isRight)}
              tag="span"
              tagStyle="bodySmall"
              title={labelRight}
            >
              {labelRight}
            </Typography>
          )}
        </label>
      </button>
    </React.Fragment>
  );
};

DualChoice.displayName = 'DualChoice';

export default DualChoice;
